// data-current holds the index of the item up front and the css places all
// three from it. Link hover, link focus and the mobile timer all just move
// that index, inside a view transition so the items animate between slots.
const gallery = document.querySelector('#expertise-gallery')

if (gallery) {
  const MOBILE_WIDTH = 1000
  const AUTOPLAY_DELAY = 4000

  const section = gallery.closest('.expertise-hero')
  const items = [...gallery.querySelectorAll('.media-item')]
  const videos = items.map(item => item.querySelector('video'))
  const links = [...section.querySelectorAll('.links-wrapper a')]
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')

  let autoplayTimer
  let resizeTimer
  let pendingVideo
  let onScreen = false

  function currentIndex() {
    return Number(gallery.dataset.current) || 0
  }

  function activate(index) {
    if (!items[index] || index === currentIndex()) return

    const mutate = () => {
      gallery.dataset.current = index
      syncPlayback()
      scheduleAutoplay()
    }

    document.startViewTransition
      ? document.startViewTransition(mutate)
      : mutate()
  }

  function activateNext() {
    activate((currentIndex() + 1) % items.length)
  }

  // only the item up front plays, the rest rewind so their next turn is a
  // full pass
  function syncPlayback() {
    const current = currentIndex()

    videos.forEach((video, index) => {
      if (!video) return

      if (index === current) return video.play().catch(() => {})

      video.pause()
      video.currentTime = 0
    })
  }

  // only runs on mobile, where there is no hover to drive the gallery, and
  // only on screen, so the page is not snapshotting transitions nobody sees
  function scheduleAutoplay() {
    clearAutoplay()

    if (!onScreen || items.length < 2) return
    if (window.innerWidth > MOBILE_WIDTH || reducedMotion.matches) return

    const video = videos[currentIndex()]
    // the lazy loader sets src on its own schedule, so ask the markup whether
    // this is a video rather than whether it has loaded
    const isVideo = video && (video.src || video.dataset.src)

    if (!isVideo) {
      autoplayTimer = setTimeout(activateNext, AUTOPLAY_DELAY)
      return
    }

    // the markup loops every video for the hover case, so the one being waited
    // on has to stop looping or it would never end
    pendingVideo = video
    video.loop = false
    video.addEventListener('ended', activateNext)

    if (!video.paused && !video.ended) return

    // buffering or refused, and a video that never starts never ends either,
    // so the delay stands in until playback takes the job back over
    autoplayTimer = setTimeout(activateNext, AUTOPLAY_DELAY)
    video.addEventListener('playing', cancelDelay)
    video.play().catch(() => {})
  }

  function cancelDelay() {
    clearTimeout(autoplayTimer)
    autoplayTimer = null
  }

  function clearAutoplay() {
    cancelDelay()

    if (pendingVideo) {
      pendingVideo.removeEventListener('ended', activateNext)
      pendingVideo.removeEventListener('playing', cancelDelay)
      // hand the looping back for the hover case
      pendingVideo.loop = true
      pendingVideo = null
    }
  }

  links.forEach((link, index) => {
    link.addEventListener('mouseenter', () => activate(index))
    // focus keeps the gallery operable by keyboard, the images are not
    link.addEventListener('focus', () => activate(index))
  })

  // a pointer in the block is driving, so nothing should pull an image away
  section.addEventListener('mouseenter', clearAutoplay)
  section.addEventListener('mouseleave', scheduleAutoplay)

  new IntersectionObserver(([entry]) => {
    onScreen = entry.isIntersecting
    scheduleAutoplay()
  }).observe(gallery)

  // catches rotation and resizing across the breakpoint
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer)
    resizeTimer = setTimeout(scheduleAutoplay, 100)
  })

  reducedMotion.addEventListener('change', scheduleAutoplay)
}
